import { ModuleType } from "./module-type";


export class AppSettings {
    private _helpAddress = '';
    private static _moduleType = ModuleType.Base;
    private static _phoneFieldEnabled = true;
    private static _telegramBotEnabled = false;

    static get PhoneFieldEnabled(): boolean {
        return this._phoneFieldEnabled;
    }
    static get ModuleType(): ModuleType {
        return this._moduleType;
    }
    static get TelegramBotEnabled(): boolean {
        return AppSettings._telegramBotEnabled;
    }
    get HelpAddress(): string {
        return this._helpAddress;
    }
    get IsDevVersion() {
        return window.location.host.toLowerCase().indexOf('test') != -1 ||
            window.location.host.toLowerCase().indexOf('localhost') != -1;
    }
    get IdentityServerUrl(): string {
        if (window.location.host.toLowerCase().indexOf('test') == -1 &&
            window.location.host.toLowerCase().indexOf('localhost') == -1) {
            return 'https://idsrv.moipass.ru/';
        } else {
            return 'https://idsrv-test.moipass.ru/';
        };
    };

    SetHelpAddress(address: string) {
        this._helpAddress = address;
    }
    SetModuleType(module: ModuleType): void {
        AppSettings._moduleType = module;
    }
    SetPhoneFieldEnabled(enabled: boolean): void {
        AppSettings._phoneFieldEnabled = enabled;
    }
    SetTelegramBotEnabled(enabled: boolean): void {
        AppSettings._telegramBotEnabled = enabled;
    }
}